import * as angular from 'angular';

(function () {
    'use strict';

    var ONLINE_HELP_URL = {
        START_PAGE: 'https://www.prisma-capacity.eu/online-help-tag/shipper/',
        DAY_AHEAD_AUCTION:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#day-ahead-auction',
        WITHIN_DAY_AUCTION:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#within-day-ahead-auction',
        LONG_TERM_AUCTION:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#long-term-auction',
        FCFS_BOOKING:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#fcfs-booking',
        SECONDARY_TRADING:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#secondary-trading',
        SURRENDER:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#surrender',
        ACCOUNT_SETTINGS:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#account-settings',
        PLATFORM_SETTINGS:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#platform-settings',
        REVERSE_AUCTION:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#reverse-auctions',
        REGISTRATION:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#registration',
        REPORTING:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#reporting',
        ADDITIONAL_SERVICES:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#additional-services',
        DASHBOARD:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#dashboard',
        DAY_AHEAD_COMFORT:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#day-ahead-comfort-bid',
        LOGIN: 'https://www.prisma-capacity.eu/online-help-tag/shipper/#login',
        NETWORK_INFO:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#network-information',
        AUCTION_OVERVIEW:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#auction_overview',
        OVERVIEW:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#general-information',
        MARKET_INFO:
            'https://www.prisma-capacity.eu/online-help-tag/shipper/#market-information'
    };

    angular.module('app').constant('ONLINE_HELP_URL', ONLINE_HELP_URL);
})();
